import * as React from 'react'
import { connect, useSelector } from 'react-redux'

import { ListItem, ListItemText, Paper, Typography } from '@material-ui/core'
import { Helmet } from 'react-helmet'
import { Page } from '../../components'
import { getLoginAdmin } from '../../state/Auth/selectors'
import { resetPasswordRequest } from '../../state/Firebase/operations'
import { State } from '../../types'
import NavBar from '../NavBarContainer'
import {
  useMoveClinetsPage,
  useMoveDevicesZyuutenPage,
  useMoveDevicesRoadcellPage,
  useMoveDevicesRoadcellZentyouPage,
  useMoveDevicesZentyouPage,
  useMoveDevicesYuatsuPage,
} from '../App/operations'
import { useAuth } from '../Auth/useAuth'

function AdminTopPageComponent() {
  const admin = useSelector(getLoginAdmin)

  const moveClinetsPage = useMoveClinetsPage()
  const moveDevicesZyuutenPage = useMoveDevicesZyuutenPage()
  const moveDevicesRoadcellPage = useMoveDevicesRoadcellPage()
  const moveDevicesRoadcellZentyouPage = useMoveDevicesRoadcellZentyouPage()
  const moveDevicesZentyouPage = useMoveDevicesZentyouPage()
  const moveDevicesYuatsuPage = useMoveDevicesYuatsuPage()

  if (!admin) return null

  return (
    <div>
      <Helmet>
        <title>運用メニュー</title>
      </Helmet>
      <NavBar />
      <Page>
        <Typography variant="h5">メニュー</Typography>
        <Paper>
          <div
            style={{
              display: 'grid',
              gridTemplateAreas:
                '"zyu cli" "roa cli" "zen cli" "roz cli" "yua other"',
            }}
          >
            <div style={{ gridArea: 'zyu' }}>
              <Typography variant="h6">ジュウテンミエルカ</Typography>
              <ul>
                <ListItem button onClick={moveDevicesZyuutenPage}>
                  <ListItemText primary="端末紐付管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'roa' }}>
              <Typography variant="h6">ロードセル</Typography>
              <ul>
                <ListItem button onClick={moveDevicesRoadcellPage}>
                  <ListItemText primary="端末紐付管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'roz' }}>
              <Typography variant="h6">ロードセル・ゼンチョウ</Typography>
              <ul>
                <ListItem button onClick={moveDevicesRoadcellZentyouPage}>
                  <ListItemText primary="端末紐付管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'yua' }}>
              <Typography variant="h6">液圧センサシステム</Typography>
              <ul>
                <ListItem button onClick={moveDevicesYuatsuPage}>
                  <ListItemText primary="端末紐付管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'zen' }}>
              <Typography variant="h6">ゼンチョウ</Typography>
              <ul>
                <ListItem button onClick={moveDevicesZentyouPage}>
                  <ListItemText primary="端末紐付管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'cli' }}>
              <Typography variant="h6">クライアント</Typography>
              <ul>
                <ListItem button onClick={() => moveClinetsPage()}>
                  <ListItemText primary="クライアント管理" />
                </ListItem>
              </ul>
            </div>
            <div style={{ gridArea: 'other' }}>
              <Typography variant="h6">その他</Typography>
              <ul>
                <ListItem
                  onClick={() => resetPasswordRequest(admin.email)}
                  button
                >
                  <ListItemText primary="パスワード変更" />
                </ListItem>
              </ul>
            </div>
          </div>
        </Paper>
      </Page>
    </div>
  )
}

const conn = connect((state: State) => ({
  admin: getLoginAdmin(state),
}))
const AdminTopPage = conn(AdminTopPageComponent)

const AdminTopPageLigin = () => {
  const res = useAuth()

  if (res.loading && res.Loader) return <res.Loader />
  if (!res.login) return null
  return <AdminTopPage />
}

export default AdminTopPageLigin
